import { Publication } from '@shared/types/publication';
import { ChevronRight } from 'lucide-react';
import PublicationCard from '@shared/components/common/PublicationCard';
import TitleAccent from './TitleAccent';

interface PublicationSectionProps {
    title: string,
    publications: Publication[],
    onShowMore?: () => void,
    onPublicationClick?: (publication: Publication) => void,
    onQuickView?: (publication: Publication) => void,
    isRankingSection?: boolean,
    totalRecord?: number,
    limit?: number
}

const PublicationSection = ({
    title,
    publications,
    onShowMore,
    onPublicationClick,
    onQuickView,
    isRankingSection,
    totalRecord = 0,
    limit = 6
}: PublicationSectionProps) => {
    return (
        <section className='container mx-auto px-4 py-8 md:py-[60px]'>
            <div className='flex items-center justify-between mb-6 md:mb-[30px]'>
                <div className='flex items-center gap-1'>
                    <TitleAccent />
                    <h2 className='font-semibold text-[20px] leading-[24px]'>
                        {title}
                    </h2>
                </div>
                <div className='flex-1 mx-[10px] h-[1px] bg-border' />
                {onShowMore && totalRecord > limit && (
                    <button
                        onClick={onShowMore}
                        className='font-semibold leading-[16px] text-primary-accent text-center flex items-center gap-[4px] transition-colors'
                    >
                        もっと見る
                        <ChevronRight className='size-6' />
                    </button>
                )}
            </div>

            <div className='grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-[24px] lg:gap-[36px] xl:gap-[48px]'>
                {publications.map((publication, index) => (
                    <PublicationCard
                        key={publication.id}
                        publication={publication}
                        onClick={onPublicationClick}
                        onQuickView={onQuickView}
                        rank={isRankingSection ? index + 1 : undefined}
                    />
                ))}
            </div>
        </section>
    );
};

export default PublicationSection;
